"use client";

import { useInView } from "react-intersection-observer";

import useSessionStore from "@/lib/stateManagement/sessionState/sessionStore";

import { useCallback, useEffect } from "react";
import styles from "./header.module.css";

const HeaderClient = ({ children }: { children: React.ReactNode }) => {
  const { ref, inView: inViewTop } = useInView({
    initialInView: true
  });
  const { ref: refBottom, inView: inViewBottom } = useInView({
    initialInView: true
  });

  const [atTop, setAtTop, scrollDirection] = useSessionStore((store) => [
    store.atTop,
    store.setAtTop,
    store.scrollDirection
  ]);

  const handleAtTop = useCallback(() => {
    if (atTop && !inViewTop) {
      setAtTop(false);
      return;
    }
    //eslint-disable-next-line
  }, [inViewTop, setAtTop]);

  const handleAtBottom = useCallback(() => {
    if (!atTop && inViewBottom) {
      setAtTop(true);
      return;
    }
    //eslint-disable-next-line
  }, [inViewBottom, setAtTop]);

  useEffect(() => {
    handleAtTop();
    handleAtBottom();
  }, [handleAtTop, handleAtBottom]);
  return (
    <>
      <nav
        className={`
        ${styles.header} 
        ${atTop ? "" : styles.scrolled} 
        ${styles.scrollDown} ${
          scrollDirection === "down" && !atTop ? styles.hidden : ""
        }
      `}
      >
        {children}
      </nav>
      <div ref={ref} className={`${styles.intersector} ${styles.top}`} />
      <div
        ref={refBottom}
        className={`${styles.intersector} ${styles.bottom}`}
      />
    </>
  );
};

export default HeaderClient;
